import { render, staticRenderFns } from "./Prevoyance.vue?vue&type=template&id=2b4e7728&"
import script from "./Prevoyance.vue?vue&type=script&lang=js&"
export * from "./Prevoyance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports